import React from "react"
import useIsMobile from "@Hooks/selector/useIsMobile"
import {isMinivanRoute} from "@Route/features/transportType/functions/isMinivanRoute"
import {isPrivateBusRoute} from "@Route/features/transportType/functions/isPrivateBusRoute"
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type"
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type"
import SuggestedRouteType from "@Route/types/SuggestedRoute.type"
import RouteClosedOrUnavailable
    from "@Route/features/status/features/closedOrUnavailable/components/RouteClosedOrUnavailable"
import Discount from "@Route/components/Price/Discount/Discount"
import RouteActionButton from "@Route/features/ticketPurchase/components/RouteActionButton"
import RouteTotalPriceContainer from "@Route/components/Price/RouteTotalPriceContainer"
import ParamsType from "@SearchResults/types/params/Params.type"
import usePassengers from "@Hooks/selector/usePassengers";
import RouteStatus from "@Route/features/status/components/RouteStatus";
import routeIsClosedOrUnavailable from "@Route/features/status/functions/routeIsClosedOrUnavailable";

interface RouteStatusContainerProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType,
    isReturn: boolean,
    params: ParamsType,
}

function RouteStatusContainer(props: RouteStatusContainerProps) {
    const {
        route,
        isReturn,
        params,
    } = props

    const {
        prices,
        status: {
            status,
            soldOut,
            isSuggestion,
            hasMTicket,
        },
        allotment: {
            totalAllotmentLeft,
        },
        travelInfo: {
            departureStation: {
                departureDate,
            },
            destinationStation: {
                arrivalDate,
            },
            seatClass,
        },
        type,
    } = route

    const passengers = usePassengers()
    const {discounts, price} = prices

    const isMobile = useIsMobile()

    const hasDiscounts = !isSuggestion && !!Object.keys(discounts)?.length && status === "open"
    const overnightTravel = departureDate !== arrivalDate
    const isMinivan = isMinivanRoute(type.routeTransferType)
    const isPrivateBus = isPrivateBusRoute(type.routeTransferType)
    const showOvernightTravel = (totalAllotmentLeft - passengers.passengers) > 10

    const isClosedOrUnavailable = routeIsClosedOrUnavailable(status)

    return (
        <div className={`gb--row gb--route-status ${isClosedOrUnavailable ? "gb--route-status__closed" : ""}`}>
            {isClosedOrUnavailable ? (
                <RouteClosedOrUnavailable
                    soldOut={soldOut}
                    closed={status === "closed"}
                    unavailable={status === "unavailable"}
                />
            ) : (
                <RouteTotalPriceContainer
                        route={route}
                        totalPrice={price}
                />
            )}
            <RouteStatus
                hasMTicket={hasMTicket}
                showOvernightTravel={showOvernightTravel}
                isMinivan={isMinivan}
                isPrivateBus={isPrivateBus}
                overnightTravel={overnightTravel}
                isPrivate={type.isPrivate}
                seatClass={seatClass}
                totalAllotmentLeft={totalAllotmentLeft}
                type={type}
            />
            {hasDiscounts && (
                <Discount
                    prices={prices}
                />
            )}
            {status === "open" && !isMobile && (
                <RouteActionButton
                    params={params}
                    route={route}
                    expandedPanel={false}
                    isReturn={isReturn}
                />
            )}
        </div>
    )
}

export default RouteStatusContainer